module.exports = __webpack_public_path__ + "img/example-litterature-contest-qr-code.e290d1f6.webp";